import React, { Component } from 'react';
import { Link } from 'react-router';

import routeConfig from '../../config/route.json';

import '../../css/bg.css';
import '../../css/landing.css';

import $ from 'jquery';

class Landing extends Component {

  constructor(props) {
    super(props);
    this.state = {
    	...this.props,
    	'bg': {
        pic1: '/p2/desktop/bg/landing/bg.png',
        pic2: '/p2/desktop/bg/landing/1.png',
        pic3: '/p2/desktop/bg/landing/2.png',
        pic4: '/p2/desktop/bg/landing/3.png',
        pic5: '/p2/desktop/bg/landing/4.png',
      },
      'bgLogo': '/p2/desktop/bg/landing/logo-fit.png',

    }
  }

  componentDidMount() {
    let t = this;
    $('#loader').fadeOut(1000)
    this.changePositioning();
    this.changePositioningTimeout = setTimeout(function(){ t.changePositioning(); }, 1000);
    window.addEventListener('resize', this.changePositioning);

    $('#App-header').fadeOut();
    $('#App-footer').fadeOut();

    $( "#bg-image-1" ).on('load', function() {
      t.pageLoad();
    });
  }

  componentWillUpdate(){}


  componentWillUnmount(){
    document.getElementById('App-header').style.opacity = '1';
    document.getElementById('App-footer').style.opacity = '1';
    $('#App-header').fadeIn();
    $('#App-footer').fadeIn();

    clearTimeout(this.changePositioningTimeout);
    window.removeEventListener('resize', this.changePositioning);
  
  }
  pageLoad () {
    let t = this;
    /* temp */
    setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
    setTimeout(function(){
      document.getElementById('bg-image-5').classList.remove('bg-flower');
    }, 4700);
    /* temp */

  }
  changePositioning() {
    let windowWidth = $('.App').width();
    let windowHeight = $('.App').height();
    let containerWidth = $('#logo-container').width();
    // $('.landing-button').css({
    //   'height': containerWidth * 0.056 + 'px',
    //   'top': containerWidth * 0.607681818 + 'px'
    // });

    $('.landing-button').css({
      'height': containerWidth * 0.056 + 'px',
      'top': containerWidth * 0.647681818 + 'px'
    });

    if (windowWidth < 1100) {
      windowWidth = 1100
    }

    let bgImage4Top = windowWidth * 0.497775833 + 'px';
    let bgImage5Top = windowWidth * 0.328333333 + 'px';

    document.getElementById('bg-image-4-container').style.top = bgImage4Top;
    document.getElementById('bg-image-5-container').style.top = bgImage5Top;

    // if (windowWidth / windowHeight - 3287 / 1849 < 0) {
    //   $('#bg-image-1').width('100%')
    //   $('#bg-image-1').height('unset')
    // } else {
    //   $('#bg-image-1').width('unset')
    //   $('#bg-image-1').height('100%')
    // }
    
  }
  
  resetHeaderFooter() {
    document.getElementById('App-header').style.opacity = '1';
    document.getElementById('App-footer').style.opacity = '1';
  }

  render() {
  	return <div className="main-page" style={{}}>
      {/* <video className='bg-image' loop autoPlay style={{
        'zIndex': '1001',
        'transform': 'scale(1.03)'
      }}>
        <source src="/p2/desktop/bg/landing/video.mp4" type="video/mp4"/>
      </video> */}
      <img src={this.state.bg.pic1} className='bg-image' id='bg-image-1' style={{ minWidth: '100%' }}/>

      <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
      <div id='bg-image-3-container'
        className='bg-image-container'
        style={{
          'width': '41.8%'
        }}>
        <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/>
      </div>

      <div id='bg-image-4-container'
        className='bg-image-container'
        style={{
          'right': '1px',
          'width': '35.8%'
        }}>
        <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/>
      </div>

      <div id='bg-image-5-container'
        className='bg-image-container'
        style={{
          'left': '38.2%',
          'width': '26.95%'
        }}>
        <img src={this.state.bg.pic5} className='bg-image bg-flower' id='bg-image-5'/>
      </div>

      {/* <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/> */}
      {/* <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/> */}
      {/* <img src={this.state.bg.pic5} className='bg-image bg-flower' id='bg-image-5'/> */}

      <div id='logo-container' style={{
          'position': 'absolute',
          'zIndex': '1002',
          'left': '31%',
          'top': '34%',
          'width': '38%'
        }}>
        <img src={this.state.bgLogo} className='bg-image' id='' style={{
          'width': '100%'
        }}/>

        <Link onClick={this.resetHeaderFooter} to={routeConfig.home.en.url}>
          <div className='landing-button' style={{
            'top': '50%',
            'height': '10%',
            'width': '15%',
            'left': '1%'
          }}></div>
        </Link>

        <Link onClick={this.resetHeaderFooter} to={routeConfig.home.tc.url}>
          <div className='landing-button' style={{
            'width': '8%',
            'left': '17.5%'
          }}></div>
        </Link>

        <Link onClick={this.resetHeaderFooter} to={routeConfig.home.sc.url}>
          <div className='landing-button' style={{
            'width': '8%',
            'left': '27%'
          }}></div>
        </Link>
      </div>

  	</div>
  }
};

export default Landing;



// WEBPACK FOOTER //
// ./src/desktop/page/Landing.js